import { createBrand } from '../factory';
import { Layout } from './Layout';
export default createBrand({
    brand: 'immowelt',
    shortBrand: 'IWT',
    template: Layout,
});
